export const Urls = {
    GetLookups: "MepLookup/GetLookups",
    GetLookupsByCustomer: "MepLookup/GetLookupsByCustomer"
}

export const Lookups = {
    FinancialYears: "financialYears",
    EmissionTypes: "emissionTypes",
    PointOfInterests: "pointOfInterests",
    VesselTypeGroups: "vesselTypeGroups",
    OperationModes: "operationModes",
    CargoTypes: "cargoTypes",
    WeightBuckets: "weightBuckets",
    Scopes: "scopes",
    Ports: "ports"
}
